import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
    selector: 'app-share-icons',
    templateUrl: './share-icons.component.html',
    styleUrls: ['./share-icons.component.scss']
})
export class ShareIconsComponent implements OnInit {
    currentUrl;

    constructor(
        private router: Router
    ) {
    }

    ngOnInit(): void {
        this.currentUrl = window.location.origin + this.router.routerState.snapshot.url;
    }

}
